import DOMPurify from "isomorphic-dompurify";

export function sanitize(html) {
  if (!html) return "";
  return DOMPurify.sanitize(html, { ADD_ATTR: ["target","rel"] });
}
